import React from 'react';
import ModulePlaceholder from '../common/ModulePlaceholder';

export default function Applications() {
  return (
    <ModulePlaceholder
      title="Applications"
      icon="🧩"
      description="Manage add-on applications and integrations for your LedgerPro company."
      related={[
        { label: 'Reports', path: '/reports' },
        { label: 'Backup & Recovery', path: '/settings/backup' },
      ]}
    />
  );
}
